import React from 'react';
import core, { API, Async } from '@gin-betting/core';

const {
    hooks: { useSubscription },
} = core;

interface Props {
    variables: API.GQLSubscriptions['onUpdateSportEvent'][1];
    origin: Async.SubscribeOrigin;
    batch: boolean;
}

const SportEventSubscription: React.FC<Props> = ({
    variables,
    batch,
    origin,
}) => {
    useSubscription({
        variables,
        config: {
            method: 'onUpdateSportEvent',
            origin,
            batch,
        },
    });

    return null;
};

export default SportEventSubscription;
